
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#bac1cc","stroke-linejoin":"round","stroke-width":"3","data-name":"vuesax/linear/courthouse"}},[_c('path',{attrs:{"d":"M4.167 45.833h41.667","stroke-linecap":"round"}}),_c('path',{attrs:{"data-name":"Vector","d":"M25 4.167a14.063 14.063 0 0010.417 0v6.25a14.063 14.063 0 01-10.417 0zM25 10.417v6.25M35.416 16.667H14.583q-6.25 0-6.25 6.25v22.917h33.333V22.917q0-6.25-6.25-6.25zM9.542 25h30.917","stroke-linecap":"round"}}),_c('path',{attrs:{"data-name":"Vector","d":"M16.646 25v20.833M24.979 25v20.833M33.313 25v20.833"}})])])
          )
        }
      }
    